import React from 'react';

export default function StatusBadge({ status }) {
  const colors = {
    'Open':                     { bg: 'var(--accent-bg)', color: 'var(--accent)', border: 'var(--accent-light)' },
    'Pending Action':           { bg: '#FFFBEB', color: '#B45309', border: '#FDE68A' },
    'Pending Approval':         { bg: '#FFF7ED', color: '#C2410C', border: '#FED7AA' },
    'Pending User Acceptance':  { bg: '#F5F3FF', color: '#6D28D9', border: '#DDD6FE' },
    'Completed':                { bg: '#ECFDF5', color: '#059669', border: '#A7F3D0' },
    'Rejected':                 { bg: '#FFF1F2', color: '#BE123C', border: '#FECDD3' },
    'Voided':                   { bg: '#F8FAFC', color: '#64748B', border: '#E2E8F0' },
    // Legacy fallbacks
    'In Progress':              { bg: '#EFF6FF', color: '#1D4ED8', border: '#BFDBFE' },
    'Resolved':                 { bg: '#ECFDF5', color: '#059669', border: '#A7F3D0' },
    'Closed':                   { bg: '#F8FAFC', color: '#64748B', border: '#E2E8F0' },
  };
  const c = colors[status] || { bg: '#F8FAFC', color: '#64748B', border: '#E2E8F0' };
  return (
    <span style={{ background: c.bg, color: c.color, border: `1px solid ${c.border}`, fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 99, whiteSpace: 'nowrap' }}>
      {status}
    </span>
  );
}
